import { Row } from '@tanstack/react-table'

import { Disruption, DisruptionStatus } from '@/types/disruptions'

const statusOrder = [
    DisruptionStatus.Live,
    DisruptionStatus.Cleared,
    DisruptionStatus.Upcoming,
    DisruptionStatus.Planned,
]

export const sortDisruptionsByStatus = (rowA: Row<Disruption>, rowB: Row<Disruption>): number => {
    const statusA = rowA.original.status
    const statusB = rowB.original.status

    const statusIndexA = statusOrder.indexOf(statusA)
    const statusIndexB = statusOrder.indexOf(statusB)

    if (statusIndexA < statusIndexB) return -1
    if (statusIndexA > statusIndexB) return 1
    return 0
}
